module.exports = __webpack_public_path__ + "img/BkgProductos.cc521cdb.jpg";